import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { setAgreeTnc } from 'redux/actions/FormAction';

import TncFormPage from './TncFormPage.page';

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAgreeTnc };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TncFormPage));
